import { jarallax } from 'jarallax';

class jarallaxModule
{
    static run () {

        jarallax(document.querySelectorAll('[data-jarallax]'));

    }
}

export default jarallaxModule;
